import type { UserRoleFlags } from '../getUserRoleFlags'

/**
 * Whether a user picks the owner of the records a self-serve import creates (#23728):
 *
 * - `required`: support and superadmin. They import for a customer, so they must name a customer user.
 * - `optional`: company admins. The owner defaults to themselves; they may pick any active user of
 *   the company. "Admin" is the legacy `admin` role, `corporate`, or a core/team account owner
 *   (`app_metadata.isOwner`).
 * - `none`: everyone else owns what they import.
 *
 * Takes `getUserRoleFlags` output, so the app (`useUser()`) and the API (token roles) apply one rule.
 */
export type ImportOwnerChoice = 'required' | 'optional' | 'none'

export function getImportOwnerChoice(
  flags: Partial<
    Pick<UserRoleFlags, 'isSupport' | 'isSuperadmin' | 'isAdmin' | 'isCorporate' | 'isCore' | 'isTeam'>
  > & {
    isOwner?: boolean
  }
): ImportOwnerChoice {
  if (flags.isSupport || flags.isSuperadmin) {
    return 'required'
  }
  if (flags.isAdmin || flags.isCorporate || ((flags.isCore || flags.isTeam) && flags.isOwner)) {
    return 'optional'
  }
  return 'none'
}
